import React from "react";
import parse from "html-react-parser";
import ssnFooterHtml from "../SingleSiteNav/footer.html";

const Footer = ({ children }) => {
  return parse(ssnFooterHtml);
};

export default Footer;
